import { libraryComponents } from '../constants/UiBuilderConst';

export const handleRemoveClick = (
  e,
  activeTabIndex,
  slidesList,
  setSlidesList,
  setActveTabIndex,
  setActveTabContent,
) => {
  if (slidesList.length > 1) {
    const tempSlideList = [...slidesList];
    tempSlideList.splice(activeTabIndex, 1);
    if (activeTabIndex === tempSlideList.length) {
      setActveTabContent(tempSlideList[activeTabIndex - 1]);
      setActveTabIndex(activeTabIndex - 1);
    } else {
      setActveTabContent(tempSlideList[activeTabIndex]);
      setActveTabIndex(activeTabIndex);
    }
    setSlidesList(tempSlideList);
  }
};
export const handleSlider = (config, ref) => {
  if (config.slides.length <= 2) {
    ref.current.state.transform = 0;
    ref.current.state.itemWidth = 72;
    ref.current.state.currentSlide = 1;
    ref.current.state.containerWidth = 150;
  }
};
export const handleSliderValues = (config, ref) => {
  if (config.slides.length <= 1 && !config.viewAll.isActive) {
    ref.current.state.transform = 0;
    ref.current.state.itemWidth = 72;
    ref.current.state.currentSlide = 1;
    ref.current.state.containerWidth = 150;
  }
};

export const getComponentTitle = (id) => {
  let title;
  libraryComponents.forEach((comp) => {
    const compObj = comp.components.find((e) => e.id === id);
    if (compObj) title = compObj.title;
  });

  return title;
};

export const getUniqueID = () => {
  return Math.random().toString(36).substr(2);
};
